"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const design_system_1 = require("@zapier/design-system");
const PathInfo_1 = require("../../utils/PathInfo");
const NodeTrees_1 = require("../../utils/NodeTrees");
const PathIcon_1 = __importDefault(require("../../legacy-editor-package/components/PathIcon"));
const common_components_1 = require("@zapier/common-components");
const PathDropdownItemStyles_1 = __importDefault(require("./PathDropdownItemStyles"));
const PathDropdownItems_1 = __importDefault(require("./PathDropdownItems"));
const SiblingTreeLine_1 = __importDefault(require("./SiblingTreeLine"));
const PathMenuItem = ({ name, color, emoji, onClick, generation, hasYoungerSibling, childPaths, onToggleDropdown, onDescendGeneration, shouldShowSiblingTreeLine, hasAunt = false, id, isDropdownOpen, isActive, }) => (core_1.jsx("div", { css: PathDropdownItemStyles_1.default.container({ isActive }) },
    core_1.jsx("div", { "aria-label": `Go to ${name}`, css: PathDropdownItemStyles_1.default.clickableSection, onClick: onClick, onKeyDown: () => { }, role: "button", tabIndex: 0 },
        shouldShowSiblingTreeLine && (core_1.jsx(SiblingTreeLine_1.default, { generation: generation, hasAunt: hasAunt, hasYoungerSibling: hasYoungerSibling, key: "tree-line" })),
        core_1.jsx("div", { css: PathDropdownItemStyles_1.default.pathIconBorder },
            core_1.jsx(PathIcon_1.default, { color: color, emoji: emoji, size: "medium" })),
        core_1.jsx("span", { css: PathDropdownItemStyles_1.default.pathName },
            core_1.jsx(common_components_1.TruncatedText, null, name))),
    !lodash_1.default.isEmpty(childPaths) && generation < 2 && (core_1.jsx("div", { onClick: onToggleDropdown, onKeyDown: () => { }, role: "button", tabIndex: 0 },
        core_1.jsx(design_system_1.Icon, { name: isDropdownOpen ? 'arrowSmallUp' : 'arrowSmallDown', size: 24 }))),
    !lodash_1.default.isEmpty(childPaths) && generation >= 2 && (core_1.jsx("div", { onClick: lodash_1.default.partial(onDescendGeneration, id), onKeyDown: () => { }, role: "button", tabIndex: 0 },
        core_1.jsx(design_system_1.Icon, { name: "arrowSmallRight", size: 24 })))));
class PathDropdownItem extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isDropdownOpen: NodeTrees_1.isNodeDescendantOf(this.props.currentNode, this.props.pathNode, this.props.flowNodes),
        };
        this.onToggleDropdown = (event) => {
            event.stopPropagation();
            this.setState(state => ({
                isDropdownOpen: !state.isDropdownOpen,
            }));
        };
    }
    render() {
        const { pathNode, flowNodes, onToggleMenu, onSelectPath, generation, hasYoungerSibling, childPaths = [], shouldShowSiblingTreeLine, hasAunt, onDescendGeneration, currentNode, } = this.props;
        const { name, color, emoji } = PathInfo_1.getPathInfo(pathNode);
        return [
            core_1.jsx(PathMenuItem, { childPaths: childPaths, color: color, emoji: emoji, generation: generation, hasAunt: hasAunt, hasYoungerSibling: hasYoungerSibling, id: pathNode.id, isActive: pathNode.id === currentNode.id, isDropdownOpen: this.state.isDropdownOpen, key: pathNode.id, name: name, onClick: () => {
                    onToggleMenu();
                    onSelectPath(Number(pathNode.id));
                }, onDescendGeneration: onDescendGeneration, onToggleDropdown: this.onToggleDropdown, shouldShowSiblingTreeLine: shouldShowSiblingTreeLine }),
            this.state.isDropdownOpen && childPaths.length > 0 && generation < 2 && (core_1.jsx("div", { css: PathDropdownItemStyles_1.default.childPaths, key: `${pathNode.id} - children` },
                core_1.jsx(PathDropdownItems_1.default, { currentNode: currentNode, flowNodes: flowNodes, generation: generation + 1, hasAunt: hasAunt, onDescendGeneration: onDescendGeneration, onSelectPath: onSelectPath, onToggleMenu: onToggleMenu, pathNodes: childPaths, shouldShowSiblingTreeLine: true }))),
        ];
    }
}
exports.default = PathDropdownItem;
